import script from "./DeliveryDetailsRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeliveryDetailsRow.vue?vue&type=script&lang=ts&setup=true"

import "./DeliveryDetailsRow.vue?vue&type=style&index=0&id=291086cf&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-291086cf"]])

export default __exports__